<template>
  <div id="pointsDetails">
    <div class="entInfoBox">
      <div class="entInfoBox-left">
        <div class="entInfoBox-left-ct">
          <div class="entIMG">
            {{
              entDetailInfo.ent_name != undefined ||
              entDetailInfo.ent_name != null
                ? entDetailInfo.ent_name.substring(2, 0)
                : ''
            }}
          </div>
          <div class="entDes">
            <div class="entDes-title overFlowHid1">
              <span>{{
                entDetailInfo.ent_name != undefined ||
                entDetailInfo.ent_name === null
                  ? entDetailInfo.ent_name
                  : '-'
              }}</span>
            </div>
            <div class="entDes-creditcode overFlowHid1">
              <span>统一信用代码：</span>
              <span class="value">{{
                entDetailInfo.credit_code != undefined ||
                entDetailInfo.credit_code === null
                  ? entDetailInfo.credit_code
                  : '-'
              }}</span>
            </div>
            <div class="entDes-address overFlowHid1">
              <span>地址：</span>
              <span class="value">{{
                entDetailInfo.address != undefined ||
                entDetailInfo.address === null
                  ? entDetailInfo.address
                  : '-'
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="entInfoBox-right">
        <div class="abledPoint">
          <div class="abledPoint-left">
            <p class="number overFlowHid1">
              {{
                entDetailInfo.current_point === null ||
                entDetailInfo.current_point === undefined
                  ? '-'
                  : Math.abs(entDetailInfo.current_point)
              }}
            </p>
            <p class="label overFlowHid1">企业可用积分</p>
          </div>
          <div class="abledPoint-right line">
            <p class="number overFlowHid1">
              NO.{{
                entDetailInfo.rank === null || entDetailInfo.rank === undefined
                  ? '-'
                  : Math.abs(entDetailInfo.rank)
              }}
            </p>
            <p class="label overFlowHid1">当前排名</p>
          </div>
        </div>
        <div class="cumuPoint">
          <div class="cumuPoint-left">
            <p class="number overFlowHid1">
              {{
                entDetailInfo.total_point === null ||
                entDetailInfo.total_point === undefined
                  ? '-'
                  : Math.abs(entDetailInfo.total_point)
              }}
            </p>
            <p class="label overFlowHid1">今年获取积分</p>
          </div>
          <div class="cumuPoint-right">
            <p class="labelNumber overFlowHid1">
              用户获取：{{
                entDetailInfo.addAutoPoint === null ||
                entDetailInfo.addAutoPoint === undefined
                  ? '-'
                  : Math.abs(entDetailInfo.addAutoPoint)
              }}
            </p>
            <p class="labelNumber overFlowHid1">
              人工添加：{{
                entDetailInfo.addPoint === null ||
                entDetailInfo.addPoint === undefined
                  ? '-'
                  : Math.abs(entDetailInfo.addPoint)
              }}
            </p>
          </div>
        </div>
        <div class="comsuPoint">
          <div class="comsuPoint-left">
            <p class="number overFlowHid1">
              {{
                entDetailInfo.consume_point === null ||
                entDetailInfo.consume_point === undefined
                  ? '-'
                  : Math.abs(entDetailInfo.consume_point)
              }}
            </p>
            <p class="label overFlowHid1">今年消费积分</p>
          </div>
          <div class="comsuPoint-right">
            <p class="labelNumber overFlowHid1">
              用户消费：{{
                entDetailInfo.subsAutoPoint === null ||
                entDetailInfo.subsAutoPoint === undefined
                  ? '-'
                  : Math.abs(entDetailInfo.subsAutoPoint)
              }}
            </p>
            <p class="labelNumber overFlowHid1">
              人工核销：{{
                entDetailInfo.subsPoint === null ||
                entDetailInfo.subsPoint === undefined
                  ? '-'
                  : Math.abs(entDetailInfo.subsPoint)
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="app-table">
      <el-tabs :tab-position="tabPosition" class="pointType">
        <el-tab-pane label="企业明细">
          <div class="searchTable shift-box">
            <div class="shift-item">
              <span>时间：</span>
              <el-date-picker
                v-model="searchDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="searchList(1)"
              >
              </el-date-picker>
            </div>
            <div class="shift-item">
              <span>积分变动：</span>
              <el-select v-model="listQuery.changeType" @change="searchList(1)">
                <el-option
                  v-for="(item, index) in changeTypes"
                  :value="item.value"
                  :label="item.label"
                  :key="'changeType' + index"
                ></el-option>
              </el-select>
            </div>
            <div class="shift-item">
              <span>变更方式：</span>
              <el-select v-model="listQuery.pointType" @change="searchList(1)">
                <el-option
                  v-for="(item, index) in pointTypes"
                  :value="item.value"
                  :label="item.label"
                  :key="'changeType' + index"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="content-container-outer tableBox">
            <el-table
              ref="multipleTable"
              v-loading="listLoading"
              :data="list"
              style="width: 100%"
            >
              <el-table-column type="index" label="序号" width="100" />
              <el-table-column label="时间" property="updateTime" />
              <el-table-column label="用户积分变动" property="point" />
              <el-table-column label="企业积分变动" property="entPoint" />
              <el-table-column
                label="变动后企业可用积分"
                property="entPointRest"
              />
              <el-table-column label="操作用户姓名" property="realName" />
              <el-table-column label="变更方式" property="pointType">
                <template slot-scope="scoap">
                  <span v-if="scoap.row.pointType === 1">人工</span>
                  <span v-else>自动</span>
                </template>
              </el-table-column>
              <el-table-column label="变更途径" property="pointRuleName">
                <template slot-scope="scope">
                  <span v-if="scope.row.pointRuleName === null || scope.row.pointRuleName === ''">-</span>
                  <span v-else>{{scope.row.pointRuleName}}</span>
              </template>
              </el-table-column>
              <el-table-column label="变更原因"  property="pointReason">
                <template slot-scope="scope">
                  <div v-if="scope.row.pointReason === null || scope.row.pointReason === ''">-</div>
                  <div v-else class="overFlowHid2" :title="scope.row.pointReason">{{scope.row.pointReason}}</div>
                </template>
              </el-table-column>
            </el-table>
            <!--翻页工具条-->
            <div class="pagination-container">
              <el-pagination
                background
                :current-page="listQuery.pageNum"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="listQuery.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="企业用户">
          <div class="searchTable shift-box">
            <div class="shift-item">
              <el-input
                placeholder="请输入用户名、姓名"
                v-model="listQuery2.keyword"
                @change="searchList2(1)"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  style="cursor:pointer;"
                  @click="searchList2(1)"
                ></i>
              </el-input>
            </div>
          </div>
          <div class="content-container-outer tableBox">
            <el-table
              ref="multipleTable"
              v-loading="listLoading2"
              :data="list2"
              :default-sort="{ prop: 'point', order: 'descending' }"
              style="width: 100%;"
              @sort-change="sortSelectChange"
            >
              <el-table-column type="index" label="序号" width="100" />
              <el-table-column label="姓名" property="realName" />
              <el-table-column label="角色" property="postOffice" />
              <el-table-column label="联系电话" property="mobile" />
              <el-table-column label="个人获得积分" property="point" sortable />
              <el-table-column label="企业实际获得积分" property="entPoint" />
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="infoUserDetail(scope.row)">查看明细</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!--翻页工具条-->
            <div class="pagination-container">
              <el-pagination
                background
                :current-page="listQuery2.pageNum"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="listQuery2.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total2"
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="用户积分明细"
      :visible.sync="dialogVisiable"
      :close-on-click-modal="false"
      width="50%"
      class="groupDialog"
    >
      <div class="userBox">
        <div class="userIMG">
          <i class="el-icon-user"></i>
        </div>
        <div class="userName">{{detailUserName}}</div>
      </div>
      <div class="recordTable">
        <el-table
          ref="multipleTable"
          v-loading="listLoading3"
          :data="list3"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" width="100" />
          <el-table-column label="时间" property="updateTime" />
          <el-table-column label="个人积分变动" property="point" />
          <el-table-column label="企业实际积分变动" property="entPoint" />
          <el-table-column label="变更途径" property="pointRuleName">
            <template slot-scope="scope">
              <span v-if="scope.row.pointRuleName === null || scope.row.pointRuleName === ''">-</span>
              <span v-else>{{scope.row.pointRuleName}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!--翻页工具条-->
        <div class="pagination-container">
          <el-pagination
            background
            :current-page="listQuery3.pageNum"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery3.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total3"
            @size-change="handleSizeChange3"
            @current-change="handleCurrentChange3"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getEntDetail,
  getEntInfoList,
  getEntUserList,
  getUserDetail
} from '@api/entPoint/details'
import {
  pointsChangeType,
  pointsPointType
} from '@/common/constant/commonConstant'
export default {
  name: 'PointsDetails',
  components: {},
  props: {},
  data() {
    return {
      // 模态框显示隐藏控制器
      dialogVisiable: false,
      // 显示用户明细的用户姓名
      detailUserName: '-',
      // 企业抬头信息
      entDetailInfo: {},
      // tabs默认值
      tabPosition: '企业明细',
      // 表格刷新控制
      listLoading: false,
      listLoading2: false,
      listLoading3: false,
      // 时间筛选框
      searchDate: [],
      // 积分变动选项
      changeTypes: pointsChangeType,
      // 积分变更方式
      pointTypes: pointsPointType,
      // 列表数据
      list: [],
      list2: [],
      list3: [],
      creditCode: this.$route.query.creditCode,
      // 列表查询条件
      listQuery: {
        creditCode: this.$route.query.creditCode,
        changeType: '',
        pointType: '',
        startDate: '',
        endDate: '',
        pageNum: 1,
        pageSize: 10
      },
      listQuery2: {
        creditCode: this.$route.query.creditCode,
        keyword: '',
        pointSort: 1,
        pageNum: 1,
        pageSize: 10
      },
      listQuery3: {
        creditCode: this.$route.query.creditCode,
        mobile: '',
        pageNum: 1,
        pageSize: 10
      },
      // 表格记录总数
      total: 0,
      total2: 0,
      total3: 0
    }
  },
  created() {},
  mounted() {
    this.getEntDetailInfo()
    this.searchList(1)
    this.searchList2(1)
  },
  watch: {},
  methods: {
    // 查询企业抬头信息
    getEntDetailInfo() {
      const that = this
      getEntDetail({ creditCode: this.creditCode }).then(res => {
        if (res.data.code === '0000') {
          that.entDetailInfo = res.data.data
        } else {
          that.$message({ type: 'error', message: res.data.msg })
        }
      })
    },
    // 查询企业列表数据
    searchList(type) {
      const that = this
      this.searchDate = this.searchDate || []
      if (this.searchDate.length === 0) {
        this.listQuery.startDate = ''
        this.listQuery.endDate = ''
      } else {
        this.listQuery.startDate = this.formateDate(this.searchDate[0]) + ' 00:00:00'
        this.listQuery.endDate = this.formateDate(this.searchDate[1]) + ' 23:59:59'
      }
      this.listQuery.pageNum = type === 1 ? 1 : this.listQuery.pageNum
      that.listLoading1 = true
      getEntInfoList(this.listQuery).then(res => {
        that.listLoading = false
        let data = res.data
        if (data.code === '0000') {
          that.list = data.data.results
          that.total = data.data.totalRecord
        } else {
          that.$message({ type: 'error', message: data.msg })
        }
      })
    },
    // 时间格式化
    formateDate(date) {
      let dateStr = ''
      let time = new Date(date)
      dateStr = dateStr + time.getFullYear() + '-'
      let month = time.getMonth() + 1
      let day = time.getDate()
      dateStr = dateStr + (month < 10 ? '0' + month : month) + '-'
      dateStr = dateStr + (day < 10 ? '0' + day : day)
      return dateStr
    },
    // 查询企业用户列表数据
    searchList2(type) {
      const that = this
      that.listLoading2 = true
      this.listQuery2.pageNum = type === 1 ? 1 : this.listQuery2.pageNum
      getEntUserList(this.listQuery2).then(res => {
        that.listLoading2 = false
        let data = res.data
        if (data.code === '0000') {
          that.list2 = data.data.results
          that.total2 = data.data.totalRecord
        } else {
          that.$message({ type: 'error', message: data.msg })
        }
      })
    },
    // 查询企业用户详情数据
    searchList3(type) {
      const that = this
      that.listLoading3 = true
      this.listQuery3.pageNum = type === 1 ? 1 : this.listQuery3.pageNum
      getUserDetail(this.listQuery3).then(res => {
        that.listLoading3 = false
        let data = res.data
        if (data.code === '0000') {
          that.list3 = data.data.results
          that.total3 = data.data.totalRecord
        } else {
          that.$message({ type: 'error', message: data.msg })
        }
      })
    },
    // 查看用户详细数据
    infoUserDetail(row) {
      this.detailUserName = row.realName
      this.listQuery3.mobile = row.mobile || ''
      this.searchList3(1)
      this.dialogVisiable = true
    },
    // 企业用户-个人获得积分排序
    sortSelectChange(value) {
      let order = value.order === 'descending' ? 1 : 0
      this.listQuery2.pointSort = order
      this.searchList2(1)
    },
    /**
     * @description 页数大小变化
     */
    handleSizeChange(value) {
      this.listQuery.pageSize = value
      this.searchList(1)
    },
    /**
     * @description 分页
     */
    handleCurrentChange(value) {
      this.listQuery.pageNum = value
      this.searchList()
    },
    /**
     * @description 页数大小变化
     */
    handleSizeChange2(value) {
      this.listQuery2.pageSize = value
      this.searchList2(1)
    },
    /**
     * @description 分页
     */
    handleCurrentChange2(value) {
      this.listQuery2.pageNum = value
      this.searchList2()
    },
    /**
     * @description 页数大小变化
     */
    handleSizeChange3(value) {
      this.listQuery3.pageSize = value
      this.searchList3(1)
    },
    /**
     * @description 分页
     */
    handleCurrentChange3(value) {
      this.listQuery3.pageNum = value
      this.searchList3()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/common/styles/variables.scss';
@import '~@/common/styles/index.scss';
@import '~@/common/styles/mjCommon.scss';
#pointsDetails {
  width: 100%;
  height: 100%;
  .entInfoBox {
    width: 100%;
    height: 140px;
    background: #fff;
    padding: 26px 20px;
    display: flex;
    justify-content: space-between;
    &-left {
      width: 38%;
      &-ct {
        display: flex;
        justify-items: flex-start;
        .entIMG {
          width: 88px;
          height: 88px;
          border-radius: 4px;
          background: rgba(0, 128, 255, 0.65);
          text-align: center;
          color: #fff;
          line-height: 88px;
          font-size: 24px;
        }
        .entDes {
          margin-left: 12px;
          width: calc(100% - 100px);
          &-title {
            font-weight: 700;
            color: rgba(0, 0, 0, 0.85);
            font-size: 20px;
            text-align: left;
            line-height: 28px;
            font-family: PingFangSC-Regular;
          }
          &-creditcode {
            font-size: 14px;
            margin-top: 12px;
            line-height: 20px;
            .value {
              color: rgba(0, 0, 0, 0.5);
            }
          }
          &-address {
            font-size: 14px;
            margin-top: 8px;
            line-height: 20px;
            .value {
              color: rgba(0, 0, 0, 0.5);
            }
          }
        }
      }
    }
    &-right {
      width: 60%;
      display: flex;
      justify-items: flex-start;
      .abledPoint {
        padding: 22px 22px;
      }
      .abledPoint::after,
      .cumuPoint::after {
        content: '';
        width: 0px;
        height: 40px;
        border-right: 1px solid rgba(213, 213, 213, 1);
        position: absolute;
        right: 0px;
        top: 24px;
      }
      .comsuPoint {
        &-left {
          padding: 22px 0px 22px 22px;
        }
      }
      .cumuPoint {
        &-left {
          padding: 22px 0px 22px 22px;
        }
      }
      & > div {
        width: 33.33%;
        display: flex;
        justify-content: space-between;
        position: relative;
        & > div {
          width: 50%;
          position: relative;
          .labelNumber {
            line-height: 17px;
            color: rgba(0, 0, 0, 0.5);
            font-size: 12px;
            &:nth-child(1) {
              margin-top: 15px;
            }
            &:nth-child(2) {
              margin-top: 24px;
            }
          }
          p {
            margin: 0px;
          }
          .number {
            height: 28px;
            color: rgba(0, 0, 0, 0.85);
            font-size: 20px;
            padding-left: 10px;
          }
          .label {
            position: relative;
            padding-left: 10px;
            font-size: 12px;
            line-height: 17px;
          }
          .label::before {
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 6px;
            background: rgba(0, 145, 255, 1);
            position: absolute;
            top: 4px;
            left: 0;
          }
        }
      }
    }
  }
  .app-table {
    margin-top: 20px;
    height: calc(100% - 160px);
    background: #fff;
    .pointType {
      width: 100%;
      height: 100%;
      text-align: center;
      padding: 20px;
    }
    .tableBox{
      height: calc(100% - 60px);
    }
  }
}
.shift-box {
  margin-bottom: 20px;
  .shift-item {
    min-width: 20% !important;
  }
}
.userBox{
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  .userIMG{
    width: 50px;
    height: 50px;
    border-radius: 50px;
    background: #0091ff;
    color: #fff;
    text-align: center;
    i{
      margin-top: 10px;
      font-size: 30px;
    }
  }
  .userName{
    margin-left: 10px;
    line-height: 50px;
    font-size: 28px;
    color: rgba(0,0,0,0.5);
  }
}
/deep/.pointType {
  .el-tabs__content{
    height: calc(100% - 60px);
    .el-tab-pane{
      height: 100%;
    }
  }
  .el-tabs__nav-scroll {
    height: 40px;
  }
  .el-tabs__nav-scroll {
    position: relative;
  }
  .el-tabs__nav {
    width: 200px;
    margin: 0px auto;
    position: absolute;
    left: 50%;
    margin-left: -100px;
  }
  .el-tabs__nav-wrap::after {
    background-color: transparent !important;
  }
  .el-tabs__item {
    height: 32px;
    line-height: 32px;
    padding: 0px 16px;
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
  .el-tabs__item:nth-child(2) {
    border-right: 0px !important;
  }
  .el-tabs__item:nth-child(3) {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
  .el-tabs__item.is-active {
    background: #0091ff;
    color: #fff;
  }
}
/deep/ .el-date-editor .el-range-separator {
  width: 20px !important;
}
/deep/.el-form-item__error{
  z-index: 999;
}
</style>
